export const initialData = {
  nome: '',
  sigla: '',
  expiration_unit: 'years',
};
export default initialData;
